import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Spin, Typography } from "antd";
import axiosInstance from "../../../configs";

import HandlingEdit from "./HandlingEdit";
import StorageEdit from "./StorageEdit";
import CukaiEdit from "./CukaiEdit";
import GeneralEdit from "./GeneralEdit";

const { Text } = Typography;

export default function InvoiceEditRouter() {
  const { id } = useParams();

  const [invoiceType, setInvoiceType] = useState(null);
  const [invoiceData, setInvoiceData] = useState(null);

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!id) {
      setError("Invoice ID not found");
      setLoading(false);
      return;
    }

    // Fetch invoice to determine type
    axiosInstance
      .get(`/finance/sales-invoices/${id}`)
      .then((res) => {
        const invoice = res.data.data;
        if (invoice) {
          setInvoiceData(invoice);
          setInvoiceType(invoice.type);
        } else {
          setError("Invoice not found");
        }
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching invoice:", err);
        setError("Failed to load invoice data");
        setLoading(false);
      });
  }, [id]);

  if (loading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "400px",
          flexDirection: "column",
          gap: "16px",
        }}
      >
        <Spin size="large" />
        <Text>Memuat data invoice...</Text>
      </div>
    );
  }

  if (error) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "400px",
        }}
      >
        <Text type="danger">{error}</Text>
      </div>
    );
  }

  // Route based on invoice type
  if (invoiceType === 1) {
    return <HandlingEdit invoiceData={invoiceData} />;
  } else if (invoiceType === 2) {
    return <StorageEdit invoiceData={invoiceData} />;
  } else if (invoiceType === 3) {
    return <CukaiEdit invoiceData={invoiceData} />;
  } else if (invoiceType === 4) {
    return <GeneralEdit />;
  }

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "400px",
      }}
    >
      <Text type="danger">Unknown invoice type: {invoiceType}</Text>
    </div>
  );
}
